import React from 'react';

import { createEntity } from '../../cell-culture/cell-culture.reducer';
import { ModalCreateEntity } from '../../../shared/components/modal-create-entity';

export const ModalCellCultureCreate = () => {
  return <ModalCreateEntity createEntity={createEntity} entityKey="cellCulture" />;
};
